import React from "react";
import { SearchInput } from "./styles";
import { GetIcon } from "../../../icons";

function Search({ theme, placeholder, value, onChange, className = "" }) {
  return (
    <SearchInput theme={theme} className={value.length > 0 ? "active " + className : className}>
      <GetIcon icon="search" />
      <input type="text" placeholder={placeholder} value={value} onChange={onChange} />
    </SearchInput>
  );
}
export default Search;
